const features = [
  {
    id: 1,
    title: '全平台聚合',
    desc: '一站聚合妖精视频、桃花视频、苹果视频、榴莲视频等 12 个主流影视平台，告别多应用切换，全网热播剧集触手可及。',
    icon: 'ri-stack-line',
    color: 'primary',
  },
  {
    id: 2,
    title: '极速更新',
    desc: '团队全天候监测各平台内容动态，热播剧集更新后 2-6 小时内完成收录，每日稳定新增 200+ 剧集资源，追剧零延迟。',
    icon: 'ri-flashlight-line',
    color: 'accent',
  },
  {
    id: 3,
    title: '高清体验',
    desc: '优先收录 1080P 高清资源，支持多分辨率自适应切换，无论电脑还是手机都能享受流畅清晰的观影体验。',
    icon: 'ri-4k-line',
    color: 'secondary',
  },
];

const colorConfig: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: { bg: 'bg-primary-100/70', iconBg: 'bg-primary-500', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-100/70', iconBg: 'bg-accent-500', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-100/70', iconBg: 'bg-secondary-500', text: 'text-secondary-700' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-shield-star-line"></i>
            核心优势
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            为什么选择嫩草视频追剧？三大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {features.map((feature) => {
            const cfg = colorConfig[feature.color];
            return (
              <div key={feature.id} className="text-center p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <div className={`w-14 h-14 mx-auto mb-5 rounded-2xl ${cfg.iconBg} flex items-center justify-center`}>
                  <i className={`${feature.icon} text-background-50 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-xl text-foreground-950 mb-3">{feature.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{feature.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}